import getYouTubeId from 'get-youtube-id'
import YouTube from 'react-youtube'

function videoHost(url: string) {
  if (url.toLowerCase().includes('youtube')) return 'YouTube'
  else if (url.toLowerCase().includes('vimeo')) return 'Vimeo'
}

interface Props {
  value: {
    url: string | undefined
  }
}

export function EmbeddedVideo({ value }: Props) {
  const { url } = value
  if (!url) return null

  const host = videoHost(url)

  switch (host) {
    case 'YouTube': {
      const id = getYouTubeId(url)
      return (
        <YouTube
          videoId={id || undefined}
          className="aspect-16/9 my-8 w-full"
          opts={{
            width: '100%',
            height: '100%',
          }}
        />
      )
    }
    case 'Vimeo': {
      const regex = /vimeo\.com\/(?:videos?\/)?(\d+)(?:\/([\w\d]+))?/
      const matches = url.match(regex)
      if (!matches) return <div>Missing Video</div>

      const id = matches[1]
      const param = matches[2]
      const src = `https://player.vimeo.com/video/${id}${param ? '?h=' + param : ''}`

      return (
        <div className="my-8">
          <iframe
            title="vimeo-player"
            src={src}
            className="aspect-16/9 w-full"
            width="640"
            height="360"
            allowFullScreen
          ></iframe>
        </div>
      )
    }
    default:
      return null
  }
}
